import { IBadge } from '@/bundles/Badge/interfaces';

export default class Badge implements IBadge {
  created: Date;
  description: string;
  icon: string;
  id: number;
  name: string;
  updated: Date;

  constructor (payload: IBadge) {
    this.id = payload.id;
    this.name = payload.name;
    this.description = payload.description;
    this.icon = payload.icon;
    this.created = payload.created;
    this.updated = payload.updated;
  }
}
